<!-- 教育局 市级,省级-课程监管 -->
<template>
<div>
    <div class="index" v-if="!detail.show">
        <!-- <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div> -->

		<div class="header">
			<div class="Homeboxtop_nav_tab">
				<span v-for="(item, index) in tabList" :class="['res-tab', { active: item.area_name === tabName }]" :key="index+item.area_name" @click="tabClick(item)">
					{{ item.area_name }}
				</span>
			</div>
		</div>
		<div class="Homeboxtop_nav_tab" style="margin-top:10px">
			<span v-for="(item, index) in tabList1" :class="['res-tab', { active: item.name === tabName1 }]" :key="index+item.name" @click="tabClick1(item)">
				{{ item.name }}
			</span>
		</div>
		
        <div style="margin-top:10px">
			<el-form :inline="true" :model="queryParams" label-width="70px">
				<el-form-item label="" label-width="90px">
                    <el-input v-model="queryParams.cname" placeholder="请输入课程名称"></el-input>
                </el-form-item>
				<el-form-item label="" label-width="90px">
                    <el-input v-model="queryParams.unit" placeholder="请输入报审单位名称"></el-input>
                </el-form-item>
				<!-- <el-form-item label="">
					<el-input v-model="queryParams.sh" placeholder="请输入审核单位名称"></el-input>
                </el-form-item> -->
				 <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                </el-form-item>
			</el-form>

            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="cname" label="课程名称" show-overflow-tooltip align="center">
                    </el-table-column>
                    <el-table-column prop="typeName" label="课程分类" align="center">
                    </el-table-column>
                    <el-table-column prop="applyOrgName" label="报审单位" show-overflow-tooltip align="center">
                    </el-table-column>
                    <el-table-column prop="auditOrgName" show-overflow-tooltip label="审核单位" align="center">
                    </el-table-column>
					<el-table-column prop="price" width="80" label="课程定价" align="center">
                    </el-table-column>
                    <el-table-column header-align="center" align="center" label="操作" width="120" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="toDetail(scope.row)">去审核</el-button>
							<el-button type="text" size="small" v-if="scope.row.auditState==='2'" @click="toOperate('确定下架课程吗?','4',scope.row)">下架</el-button>
							<el-button type="text" size="small" v-if="scope.row.auditState==='4'" @click="toOperate('确定上架课程吗?','2',scope.row)">上架</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
    <Detail :info.sync="detail.info" v-show="detail.show" @to-index="toIndex" :auditState="auditState"></Detail>
</div>
</template>
<script>
import educationApi from '@/api/education/index.js';
import { getDetail } from "@/api/mechanismApi/curriculum";
import util from '@/utils/util.js';
export default {
    components:{
        Detail: ()=>import('@/views/education/courseManager/area/courseCheck/detail.vue')
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				cname: '',
				unit:'',
				sh:'',
				auditState:'',
			},
			shList:[

			],
			tableData: [],
            detail:{
                info:{},
                show:false,
            },
			school_info:JSON.parse(sessionStorage.getItem('classList')),
			userInfo:JSON.parse(sessionStorage.getItem('userInfo')),
			tabList:[],
			tabName:'全省',
			proviceCode:'',	// 省编码
			cityCode:'',	// 市编码
			areaCode:'',	// 区编码
			tabList1:[{name:'审核通过'},{name:'审核不通过'},{name:'待审核'},],
			tabName1:'审核通过',
			auditState:'1',
		}
	},
	watch:{
		tabName(n,o){
			let arr = this.tabList.filter(e=>e.area_name===n);
			if(this.org_type==='p'){
				if(n==='全省'){
					this.cityCode='';
				}else{
					this.cityCode=arr[0].area_code;
				}
			}else{
				if(n==='全市'){
					this.areaCode='';
				}else{
					this.areaCode=arr[0].area_code;
				}
			}
			this.getDataList();
		},
		tabName1(n,o){
			this.searchFun();
		},
	},
	computed:{
		// 教育局级别判断	省级:99  市级:1,10  区县级:2,20,4,40
		org_type(){
			let str = '';
			if(sessionStorage.getItem("user_level") === "99"){
				str = 'p'
			}
			if(["1", "10"].indexOf(sessionStorage.getItem("user_level")) > -1){
				str = 'c'
			}
			return str;
		},
	},
	mounted() {
		
	},
	created() {
		let areaList=JSON.parse(sessionStorage.getItem('areaList'))||[]
		if(this.org_type==='p'){
			this.proviceCode=this.userInfo.province_code;
			this.tabList=[
				{area_name:'全省',area_code:this.userInfo.province_code},
				...areaList,
			]
		}else{
			this.proviceCode=this.userInfo.province_code;
			this.cityCode=this.userInfo.city_code;
			this.tabList=[
				{area_name:'全市',area_code:this.userInfo.city_code},
				...areaList,
			]
		}
		this.tabName=this.tabList[0].area_name;
		this.getDataList();
	},
	methods: {
		tabClick(item){
			this.tabName=item.area_name;
		},
		tabClick1(item){
			this.tabName1=item.name;
		},
		async getDataList() {
			let state='2';
			if(this.tabName1==='审核通过'){
				state='2'
			}else if(this.tabName1==='审核不通过'){
				state='3'
			}else{
				state='1'
			}
			let params = {
				pageNum:this.pageNum,
				pageSize:this.pageSize,
				proviceCode:this.proviceCode,	// 省编码
				cityCode:this.cityCode,	// 市编码
				areaCode:this.areaCode,	// 区编码
				auditState:this.queryParams.auditState,
				cname:this.queryParams.cname,
				auditState:state,
				reportOrgName:this.queryParams.unit,	// 报审单位名称
				auditOrgId:'',	// 报审单位id
			}
			let res = await educationApi.getProviceCourseList(params);
			if(res.result==='000000'){
				this.tableData=res.data?.list || [];
				this.totalPage=res.data?.total || 0;
			}
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        async toDetail(item){
			this.auditState=item.auditState
			let params = {
				id: item.cid,
			};
			let paramsData= {
			cid: item.cid,
			orgId:sessionStorage.getItem("orgId"),
			};
			var { result,data } = await getDetail(params);
			let res= await educationApi.getEducationCourseauditrecord(paramsData);
			if (result == "000000") {
				this.detail.info = data;
				if(res.result==='000000'){
					this.detail.info.operateList=res.data || [];
				}
				this.detail.show = true;
			} else {
				this.$message({
				type: "error",
				message: "获取信息失败",
				});
			}
        },
		// 上架/下架课程
		async toOperate(text,type,item){
			let vm=this;
			util.handleCofirm(text, 'info',).then(async res => {
				let params = {
					cid: item.cid,
					auditState:type,
					operateOpinion:'',
					orgId:sessionStorage.getItem('orgId'),
				};
				let { result }= await educationApi.educationCourseOperate(params);
				if (result == "000000") {
					vm.$message({type: "success",message: "操作成功",});
					vm.getDataList();
				} else {
					vm.$message({type: "error",message: "操作失败",});
				}
			}).catch(err => {
				console.log('err', err) // cancel
			})
        },
        toIndex(){
            this.detail.show=false;
			this.getDataList()
        },
	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.Homeboxtop_nav_tab{
		margin-top: 2%;
	}
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	.header{
		display: flex;
	}

	::v-deep .el-form .el-input__inner {
		width: 160px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
.Homeboxtop_nav_tab{
	span{
		padding-bottom: 10px;
	}
}
</style>
